import GradientSpinner from "./GradientSpinner";

export default GradientSpinner